import DebtorTracking from '@/views/debtorTracking/DebtorTracking.vue'

const router = {
    path: '/debtor-tracking',
    name: 'Debtor Tracking',
    component: DebtorTracking,
    meta: {
        title: 'Debtor Tracking'
    }
  };

export default router
